<template>
    <b-container class="container-panel">
        <b-card no-body>
            <b-tabs content-class="mt-3">
                <b-tab title="Enroll in Payment Plan">
                    <b-card-header><h3>{{$t('ENROLL_IN_PAYMENT_PLAN')}}</h3></b-card-header>
                    <b-card-body>
                        <div v-if="EnrollDisplay.canEnroll && depositInfo.hasDeposit" class="mx-2">
                            <p style="color: red">{{depositInfo.depositMessage}}</p>
                        </div>
                        <b-row>
                            <div v-if="canWrite" class="mx-2">
                                <b-button class="btn btn-primary" variant="primary" :disabled='!EnrollDisplay.canEnroll' @click="onClickButton">Enroll</b-button>
                            </div>
                            <div v-if="canCancel" class="mx-2">
                                <PaymentPlanCancelModal class="pr-2" :paymentPlan=ActivePlan :user="user" @close="refreshPaymentPlan">Cancel</PaymentPlanCancelModal>
                            </div>
                        </b-row>
                        <div v-if="EnrollDisplay && EnrollDisplay.displayText">
                            <p>{{EnrollDisplay.displayText}}</p>
                        </div>
                    </b-card-body>
                </b-tab>
                <b-tab title="Current Payment Plan">
                    <b-card-header><h3>{{$t('CURRENT_PAYMENT_PLAN')}}</h3></b-card-header> <!--Payment Plan Activated, Pay Now, Cancel Plan, Display when no Active Payment Plan-->
                    <b-card-body v-if="ActivePlan.length > 0">
                        <b-table :items="ActivePlan" :fields="ActivePlanFields" striped outlined>
                            <template #cell(invAmount)="row">
                                ${{row.item.invAmount}}
                            </template>
                            <template #cell(balance)="row">
                                ${{Number.parseFloat(row.item.balance).toFixed(2)}}
                            </template>
                        </b-table>
                        <b-table :items="ActivePlanInvoices" :fields="ActivePlanInvoicesFields" striped outlined>
                            <template #cell(invoiceAmount)="row">
                                ${{Number.parseFloat(row.item.invoiceAmount).toFixed(2)}}
                            </template>
                            <template #cell(invoiceDate)="row">
                                {{ new Date(row.item.invoiceDate).toLocaleDateString() }}
                            </template>
                        </b-table>
                        <b-table :items="ActivePlanInstallments" :fields="ActivePlanInstallmentsFields" striped outlined>
                            <template #cell(amountDue)="row">
                                ${{Number.parseFloat(row.item.amountDue).toFixed(2)}}
                            </template>
                            <template #cell(paymentReceived)="row">
                                ${{Number.parseFloat(row.item.paymentReceived).toFixed(2)}}
                            </template>
                            <template #cell(unpaidAmt)="row">
                                ${{Number.parseFloat(row.item.unpaidAmt).toFixed(2)}}
                            </template>
                        </b-table>
                    </b-card-body>
                    <b-card-body v-else>
                        <h5> No active payment plan.</h5>
                    </b-card-body>
                </b-tab>
                <b-tab title="Payment Plan History">
                    <b-card-header><h3>{{$t('PAYMENT_PLAN_HISTORY')}}</h3></b-card-header>
                    <b-card-body v-if="History.length > 0">
                        <b-table :items="History" :fields="HistoryTableFields" striped outlined>
                            <template #cell(amount)="row">
                                ${{Number.parseFloat(row.item.amount).toFixed(2)}}
                            </template>
                            <template #cell(details)="row">
                                <PaymentPlanDetailsModal :paymentPlanNumber="row.item.payPlanNbr" />
                            </template>
                        </b-table>
                    </b-card-body>
                    <b-card-body v-else>
                        <h5> No payment plan history.</h5>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script>
    import AmbitLogo from '../components/AmbitLogo.vue';
    import Email from '../components/Email.vue';
    import LanguageSelection from '../components/LanguageSelection.vue';
    import Repo from '../repo';
    import { mapGetters } from 'vuex';
    import PaymentPlanDetailsModal from '../components/PaymentPlanDetailsModal.vue';
    import PaymentPlanCancelModal from '../components/PaymentPlanCancelModal.vue';

    export default {
        name: "PaymentPlanReview",
        props: {
            permissions: Array,
            user: String,
            depositInfo: Object
        },
        components: { AmbitLogo, Email, LanguageSelection, PaymentPlanDetailsModal, PaymentPlanCancelModal},
        data() {
            return {
                isModalVisible: false,
                showForm: false,
                showEmail: false,
                canWrite: false,
                canCancel: false,
                EnrollDisplay: {
                    canEnroll: false,
                    canCancel: false
                },
                HasDepositMessage: "",
                HasDeposit: false,
                History: [],
                ActivePlan: [],
                ActivePlanNbr: 0,
                ActivePlanInvoices: [],
                ActivePlanInstallments: [],
                Test: null,
                ActivePlanFields: [
                    { key: 'paymentPlan', label: 'Payment Plan' },
                    { key: 'enrollmentDate', label: 'Enrollment Date' },
                    { key: 'invAmount', label: 'Plan Amount' },
                    { key: 'balance', label: 'Balance' }
                ],
                ActivePlanInvoicesFields: [
                    { key: 'invoiceNum', label: 'Invoice Number' },
                    { key: 'invoiceDate', label: 'Invoice Date' },
                    { key: 'invoiceAmount', label: 'Invoice Amount' }
                ],
                ActivePlanInstallmentsFields: [
                    { key: 'installmentDueDate', label: 'Installment Date' },
                    { key: 'amountDue', label: 'Amount Due' },
                    { key: 'paymentReceived', label: 'Payment Received' },
                    { key: 'unpaidAmt', label: 'Payment Pending' }
                ],
                HistoryTableFields: [
                    { key: 'paymentPlan', label: 'Payment Plan' },
                    { key: 'enrollmentDate', label: 'Enrollment Date' },
                    { key: 'payStatusDesc', label: 'Status' },
                    { key: 'endDate', label: 'End Date' },
                    { key: 'invDate', label: 'Invoice Date' },
                    { key: 'amount', label: 'Amount' },
                    { key: 'details', label: '' }
                ]
            }
        },
        mounted: async function () {
            await this.getPaymentPlanReview(this.$route.params.customerNumber);
            await this.getDeferredPaymentPlanInformation(this.$route.params.customerNumber, true, 0);
            this.$store.dispatch('shell/updateLanguageFromQuery', this.$route.query.lang);
            this.checkCanWrite();
            this.checkCanCancel();

            console.log('log 2')
            console.log(this.depositInfo)
        },
        methods: {
            changePage(page) {
                this.showForm = page === "form";
                this.showEmail = page === "email";
            },
            getPaymentPlanReview(customerNbr) {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('shell/turnOnSpinner', true);
                    Repo.PaymentPlanService.GetPaymentPlanReview({ customerNumber: customerNbr }).then(res => {
                        this.ActivePlan = res.getActivePaymentPlanResponse.activePlans;
                        this.ActivePlanInvoices = res.getPaymentPlanInvoicesResponse.invoices;
                        this.ActivePlanInstallments = res.getPayPlanInstallmentsResponse.installments;
                        if (this.ActivePlanInstallments != null) {
                            this.ActivePlanInstallments.forEach(x => {

                                if (x.installmentDueDate == '9998-12-31T23:59:59.997') {
                                    x.installmentDueDate = '';
                                } else {
                                    let formatDate = new Date(x.installmentDueDate);
                                    x.installmentDueDate = formatDate.getMonth() + 1 + "/" + formatDate.getDate() + "/" + formatDate.getFullYear();
                                    console.log(x.installmentDueDate)
                                }
                                x.paymentReceived = x.amountDue - x.unpaidAmt;
                            });
                        }
                        this.History = res.getCustomerPaymentPlanHistoryResponse.history;
                        this.EnrollDisplay = res.getPaymentPlanDisplayResponse;
                        
                        this.$store.dispatch('shell/turnOffSpinner', false);
                        resolve(true);
                    });
                })
            },
            getDeferredPaymentPlanInformation(customerNbr, isDefaultFirstInstallmentAmount, firstInstallmentAmount) {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('shell/turnOnSpinner', true);
                    Repo.PaymentPlanService.GetDeferredPaymentPlanInformation({
                        customerNbr: customerNbr
                        , IsDefaultFirstInstallmentAmount: isDefaultFirstInstallmentAmount
                        , FirstInstallmentAmount: firstInstallmentAmount
                    }).then(res => {
                        console.log(res);
                        if (res.canEnroll != null && res.canEnroll == true) {
                            this.HasDeposit = res.HasDeposit;
                            this.HasDepositMessage = res.HasDepositMessage;                      
                        }
                        this.$store.dispatch('shell/turnOffSpinner', false);
                        resolve(true);
                    });
                });
            },
            showModal() {
                this.isModalVisible = true;
            },
            closeModal() {
                this.isModalVisible = false;
            },
            onClickButton() {
                this.$emit('enroll')
            },
            refreshPaymentPlan: async function () {
                this.$emit('close');
                return;
            },
            checkCanWrite() {
                if (this.permissions.includes(105100)) {
                    this.canWrite = true;
                }
                return;
            },
            checkCanCancel() {
                if (this.permissions.includes(105104)) {
                    this.canCancel = true;
                }
                return;
            }
        },
        watch: {
            permissions: function (newVal, oldVal) {
                this.checkCanWrite();
                this.checkCanCancel();
            }
        }
    }
</script>

<style scoped>
    .btn.btn-primary[disabled] {
        background-color: #6c757d;
    }
</style>
